import { render, staticRenderFns } from "./validasi_surat.vue?vue&type=template&id=51da2fc7&"
import script from "./validasi_surat.vue?vue&type=script&lang=js&"
export * from "./validasi_surat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports